<app-vizient-assessment 
    [opinion]="opinion"
    [crossReference]="crossReference"
    [userEmail]="user?.emailAddress"
    [userOrgId]="user?.organization?.id"
    [crossReferenceOpinionOptions]="vizientAssessmentGridData?.crossReferenceOpinionOptions"
    [hasPermissionToAddOpinions]="vizientAssessmentGridData?.hasPermissionToAddOpinions"
    [isGPO]="user?.isGPO"
    (updateOpinion)="onUpdateOpinion($event)"
    (addNote)="onAddNote($event)"
>
</app-vizient-assessment>